import { createFileRoute } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'

import { useCreateGiftCard } from '@/api/api-mutations'
import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { useAppForm } from '@/components/form/form'
import { RouteModal, useRouteModal } from '@/components/route-modal'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/_general/products/gift-cards/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.GiftCard.CreateTitle()
	}
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<CreateGiftCardPlaceholder />
		</RouteModal>
	)
}

function CreateGiftCardPlaceholder() {
	const { L } = useI18n()
	const { handleSuccess } = useRouteModal()
	const createGiftCard = useCreateGiftCard()

	const form = useAppForm({
		defaultValues: {
			name: '',
			amount: {
				value: 0,
				precision: 2
			},
			currencyCode: 'ISK'
		},
		onSubmit: async ({ value }) => {
			// await createGiftCard({
			// 	body: {
			// 		name: value.name,
			// 		amount: value.amount,
			// 		currencyCode: value.currencyCode
			// 	}
			// })
		}
	})

	return (
		<>
			<Drawer.Header>
				<Drawer.Title asChild>
					<Heading>{L.GiftCard.CreateTitle()}</Heading>
				</Drawer.Title>
			</Drawer.Header>
			<Drawer.Body className='flex flex-col items-center justify-center gap-6'>
				<div className='text-center'>
					<div className='mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100'>
						<AlertTriangle className='h-6 w-6 text-yellow-600' />
					</div>
					<p className='text-muted-foreground mt-4 text-sm'>NotImplemented</p>
				</div>
			</Drawer.Body>
			<Drawer.Footer>
				<div className='flex justify-end'>
					<Drawer.Close asChild>
						<Button variant='secondary' size='small'>
							{L.General.Cancel()}
						</Button>
					</Drawer.Close>
				</div>
			</Drawer.Footer>
		</>
	)
}
